import { DeleteReceiption } from "../Adapters/DeleteReceiption";

export const delete_receiption = (id, setReceptions, idTestimontial) => {
  DeleteReceiption(id, setReceptions, idTestimontial);
};
